// extracted by mini-css-extract-plugin
export default {"h1":"Error404_h1__6DSNT","error":"Error404_error__rZjC-","intouch":"Error404_intouch__12AP3"};